module.exports = __webpack_public_path__ + "media/custom/images/img20-e62f88b3a4d4e2d80f8904a0bb87ad16.png";